exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li\r\n{\r\nlist-style: none;\r\n}\r\n\r\nli:hover{\r\n    background-color: lightgray;\r\n}\r\n\r\n.navbar_color\r\n{\r\nbackground-color: #F8F8F8;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/navbar/navbar.component.css
// module id = ../../../../../src/app/components/navbar/navbar.component.css
// module chunks = main